import React from "react";
const LibraryContext = React.createContext({});
export const LibraryProvider = LibraryContext.Provider;
export default LibraryContext;

